import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  logo: {
    height: 48,
    width: 'auto',
    cursor: 'pointer',
    flexShrink: 0,
  },
});

interface LogoProps {
  src: string;
  alt: string;
  onClick: () => void;
}

export const Logo: React.FC<LogoProps> = ({ src, alt, onClick }) => {
  const classes = useStyles();
  return <img src={src} alt={alt} className={classes.logo} onClick={onClick} />;
};
